// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"b4580669","249":"b4580669","342":"b4580669","690":"b4580669"}[chunkId] + ".chunk.css";
};